<script setup lang="ts">
import { computed } from 'vue';
import {
  CdrText,
} from '@rei/cedar';
import { useIcons } from '../../../../common/composables/useIcons';
import { HelpTopicCard } from '../../../../api/types/HelpTopicCard';
import { THelpCenterCategory } from '../../models/types/HelpCenterCategory';

const props = defineProps<{
  helpCenter?: HelpTopicCard,
  helpCenterCategory?: THelpCenterCategory,
}>();

const isHelpCenter = computed(() => props.helpCenter !== undefined);
const isBackButton = computed(() => props.helpCenterCategory?.isBackButton === true);
const keyValue = computed(() => (isHelpCenter.value ? props.helpCenter?.helpCenterName : props.helpCenterCategory?.header));
const isNested = computed(() => !isHelpCenter.value && props.helpCenterCategory.isNested);
</script>

<template>
  <div
    v-if="!isBackButton"
    :key="keyValue"
    :data-ui="keyValue"
    class="help-centers-u__card"
    tag="button"
    role="button"
    tabindex="0"
  >
    <div class="help-centers-u__card-content">
      <div
        v-if="isHelpCenter"
        class="help-centers-u__icon-div"
      >
        <component
          :is="useIcons(isHelpCenter ? helpCenter.helpCenterIcon : 'IconReturns')"
          class="help-centers-u__icon"
        />
      </div>
      <div>
        <CdrText
          tag="h1"
          class="help-centers-u__card-header"
        >
          {{ isHelpCenter ? helpCenter.helpCenterName : helpCenterCategory.header }}
        </CdrText>
        <CdrText
          tag="p"
          class="help-centers-u__card-label"
          v-if="isHelpCenter"
        >
          {{ helpCenter.helpCenterDescription }}
        </CdrText>
      </div>
    </div>
    <component
      :is="useIcons(isHelpCenter || isNested ? 'IconCaretRight' : 'IconCaretDown')"
      class="help-centers-u__icon help-centers-u__icon--caret"
    />
  </div>
  <div
    v-else
    class="help-centers-u__card help-centers-u__card--active"
  >
    <div class="help-centers-u__caret-div">
      <component
        :is="useIcons('IconCaretLeft')"
        class="help-centers-u__icon"
      />
    </div>
    <div class="help-centers-u__card-content help-centers-u__card-content--active">
      <div>
        <component
          :is="useIcons(isHelpCenter ? helpCenter.helpCenterIcon : 'IconReturns')"
          class="help-centers-u__icon"
        />
      </div>
      <CdrText
        tag="h1"
        class="help-centers-u__card-header"
      >
        {{ helpCenterCategory.header }}
      </CdrText>
    </div>
  </div>
</template>

<style lang="scss">
  @import 'src/main/style/helpCenterColumnsUpdate.scss';
</style>
